import { gql } from '@src/__generated__';

// TODO: this is really a query it does not write any data, it returns the results!

export const CREATE_RESULT_MAP = gql(`
  mutation CreateResultsMap(
    $tripProfileId: ID!
    ) {
    createResultsMap(
      tripProfileId: $tripProfileId
    )
  }
`);
